import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M10.5425645,17 C10.5629643,17 10.5833642,16.9994505 10.604364,16.9983514 C10.8179623,16.9824149 11.0165606,16.8867959 11.1515595,16.7340253 L17.8259052,9.16803502 C18.097703,8.8597462 18.0455034,8.40857841 17.7095061,8.15963931 C17.3729089,7.91015067 16.8803129,7.9585097 16.6085151,8.26679852 L10.4531652,15.2442374 L7.30679085,12.6449395 C6.98579346,12.3795143 6.49079749,12.4036939 6.20159985,12.6971453 C5.91180221,12.9911462 5.937602,13.4445121 6.25859939,13.7093877 L10.0181688,16.815906 C10.1627676,16.9346054 10.3499661,17 10.5425645,17 Z"
  }));
});
var StatusApprove = AbstractIcon.withComponent(Icon);
StatusApprove.displayName = 'StatusApprove';
export default StatusApprove;